<template>
	<svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M6.83333 20.5H5.125V13.6667C5.125 11.7797 6.65469 10.25 8.54167 10.25H15.375M6.83333 20.5V30.75C6.83333 32.637 8.36303 34.1667 10.25 34.1667H30.75C32.637 34.1667 34.1667 32.637 34.1667 30.75V20.5M6.83333 20.5H17.0833M15.375 10.25V8.54167C15.375 6.65469 16.9047 5.125 18.7917 5.125H22.2083C24.0954 5.125 25.625 6.65469 25.625 8.54167V10.25M15.375 10.25H25.625M34.1667 20.5H35.875V13.6667C35.875 11.7797 34.3454 10.25 32.4583 10.25H25.625M34.1667 20.5H23.9167M17.0833 20.5V17.0833H23.9167V20.5M17.0833 20.5V23.9167H23.9167V20.5"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
	</svg>
</template>



	